import { render, staticRenderFns } from "./AdvertComp.vue?vue&type=template&id=5ac2ca38&scoped=true"
import script from "./AdvertComp.vue?vue&type=script&lang=js"
export * from "./AdvertComp.vue?vue&type=script&lang=js"
import style0 from "./AdvertComp.vue?vue&type=style&index=0&id=5ac2ca38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2ca38",
  null
  
)

export default component.exports